var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgRefresh = function SvgRefresh(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "refresh_svg__a",
    width: 12,
    height: 12,
    x: 1,
    y: 1,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#323232",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M11.368 2.706v2.063H9.306m1.793 0a4.666 4.666 0 0 0-8.766 2.23 4.667 4.667 0 0 0 9.334 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "refresh_svg__b",
    width: 12,
    height: 12,
    x: 1,
    y: 1,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#323232",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3.938 4.813H1.75V2.624M12.25 7A5.247 5.247 0 0 0 2.232 4.812m7.83 4.376h2.188v2.187M1.75 7a5.247 5.247 0 0 0 10.018 2.188"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#refresh_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h14v14H0z"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgRefresh);
export default ForwardRef;